// extracted by mini-css-extract-plugin
export default {"tab":"CardTab_tab__-6HjO","selected":"CardTab_selected__PHTDl","whiteColor":"CardTab_whiteColor__O2WD0","greyColor":"CardTab_greyColor__HnfnZ","title":"CardTab_title__PzOWV"};